import * as React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import { StaticImage } from "gatsby-plugin-image"
import {
    container,
    heading,
    navLinkText,
    siteTitle,
    background,
    body,
    navbar,
    footertext
  } from './layout.module.css'
  
  const Layout = ({ pageTitle, children }) => {
    const data = useStaticQuery(graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `)
  
  return (
    <div className={background}><br />
      <div className={container}>

        <header className={siteTitle}><StaticImage src="../images/GEBL-Logo-2022-98x98-1.webp" alt="GEBL Logo" />{data.site.siteMetadata.title}</header>
        
        <div align="center">
            <nav className={navbar}>
                <Link to="/" className={navLinkText}>Home</Link>  |  <Link to="/calendar" className={navLinkText}>Calendar</Link>  |  <Link to="/news" className={navLinkText}>News</Link>  |  <Link to="/recipes" className={navLinkText}>Recipes</Link>  |  <Link to="/about" className={navLinkText}>About</Link>  
          </nav>
        </div>

        <br />

        <main>
          <h1 className={heading}>{pageTitle}</h1>
          <br />
          <div className={body}>
          {children}
          </div>
        </main>

        <br />

        <div align="center">
            <nav className={navbar}>
                <Link to="/" className={navLinkText}>Home</Link>  |  <Link to="/calendar" className={navLinkText}>Calendar</Link>  |  <Link to="/news" className={navLinkText}>News</Link>  |  <Link to="/recipes" className={navLinkText}>Recipes</Link>  |  <Link to="/media" className={navLinkText}>Media</Link>  |  <Link to="/about" className={navLinkText}>About</Link>  
          </nav>
        </div>

        <br />

        <div className={footertext}>
          Greater Everett Brewer's League (GEBL) © 2025
          <br />
          <Link to="/privacy">Privacy Policy & Website Credits</Link>
        </div>

        <br />

      </div>
    </div>
  )
}

export default Layout